import React, { useEffect, useState } from 'react';
import './nfdPlatformStartSection.scss';
import { ReactComponent as NfdPlatformLogo } from "./components/NfdPlatformLogo.svg";
import { ReactComponent as NfdPlatformLogoText } from "./components/NfdPlatformLogoText.svg";

const NfdPlatformStartSection = () => {
	const [width, setWidth] = useState(window.innerWidth);
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);
	
	return (
		<div className="nfdPlatformStart">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="nfdPlatformStart__content">
				<div className="nfdPlatformStart__content_logo">
					<NfdPlatformLogo />
					<NfdPlatformLogoText />
				</div>
				<div className="nfdPlatformStart__content_data">
					<div className="nfdPlatformStart__content_data_text">
						{
							width > 767 ? (
								<div className="nfdPlatformStart__content_data_text_title">
									<div className="nfdPlatformStart__content_data_text_title_row">
										<h1>All the</h1>
										<div className="circle"/>
										<h1>crypto space</h1>
									</div>
									<div className="nfdPlatformStart__content_data_text_title_row">
										<h1>in one</h1>
										<div className="ellipse"/>
										<h1>place</h1>
									</div>
								</div>
							) : (
								<div className="nfdPlatformStart__content_data_text_title">
									<div className="nfdPlatformStart__content_data_text_title_row">
										<h1>All the crypto space in one place</h1>
									</div>
								</div>
							)
						}
						<span>Platform for discovering, participating in, and tracking all information related to crypto projects</span>
					</div>
					<div className="nfdPlatformStart__content_data_button">
						<button
							className="secondButton"
							onClick={() => {}}
						>
							<span>Open Free App</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NfdPlatformStartSection;